// Detects whether the app is running inside the Android Play Store build
// (a Trusted Web Activity wrapping urava.app), so we can hide in-app purchase
// CTAs. Google Play requires Play Billing for digital purchases made *inside*
// an app, so the TWA build keeps payments web-only — users subscribe on
// urava.app in a browser instead. See manifest start_url "?source=twa".

const TWA_FLAG_KEY = 'is_twa';

// Call once on app boot. The TWA launches the manifest start_url which carries
// ?source=twa; we persist that to localStorage so it survives SPA navigation
// (the query param is gone after the first client-side route change). We also
// honour the android-app:// referrer that a TWA sets on the initial document.
export function initPlatform(): void {
  try {
    if (localStorage.getItem(TWA_FLAG_KEY) === '1') return;
    const fromQuery = new URLSearchParams(window.location.search).get('source') === 'twa';
    const fromReferrer = document.referrer.startsWith('android-app://');
    if (fromQuery || fromReferrer) {
      localStorage.setItem(TWA_FLAG_KEY, '1');
    }
  } catch {
    // localStorage may throw in private mode — fail open (treat as web).
  }
}

// True when running inside the Play Store TWA build. Used to hide purchase /
// upgrade CTAs so the Android app never initiates a payment.
export function isTwa(): boolean {
  try {
    return localStorage.getItem(TWA_FLAG_KEY) === '1';
  } catch {
    return false;
  }
}
